import type { ActivityEventFilterItem } from "../../../api/useActivityEvents";
import type { ActivityEventId } from "../../../api/useActivities";

export const getActivityEventFilterKey = (event: ActivityEventFilterItem) => {
  if (event.type === "FAULT_EVENT") {
    return event.id.faultEventId;
  }

  if (event.type === "MANUAL_FAULT_EVENT") {
    return event.id.manualFaultEventId;
  }

  throw new Error("Unsupported activity event filter type");
};

export const mapActivityEventFilterValues = (
  values: string[],
  events: ActivityEventFilterItem[],
): ActivityEventId[] => {
  const eventIndex = new Map(events.map(event => [getActivityEventFilterKey(event), event]));

  return values.flatMap<ActivityEventId>(value => {
    const event = eventIndex.get(value);
    if (!event) return [];
    if (event.type === "FAULT_EVENT") {
      return [
        {
          type: "FAULT_EVENT" as const,
          id: {
            faultEventId: event.id.faultEventId,
            faultEventProjectId: event.id.faultEventProjectId,
            faultEventFailureName: event.id.faultEventFailureName,
            faultEventStartsAt: new Date(event.id.faultEventStartsAt),
          },
        },
      ];
    }

    if (event.type === "MANUAL_FAULT_EVENT") {
      return [
        {
          type: "MANUAL_FAULT_EVENT" as const,
          id: {
            manualFaultEventId: event.id.manualFaultEventId,
          },
        },
      ];
    }

    return [];
  });
};
